import { render, staticRenderFns } from "./ClimateProjectionNodes.vue?vue&type=template&id=664d5079&"
import script from "./ClimateProjectionNodes.vue?vue&type=script&lang=js&"
export * from "./ClimateProjectionNodes.vue?vue&type=script&lang=js&"
import style0 from "./ClimateProjectionNodes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports